<template>
  <div class="p-condition-result">
    <div
      class="p-condition-result__data"
      :class="{'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }"
    >
      <div class="c-loader c-loader"></div>
      <div class="c-empty">
        <div class="c-empty__text">
          配信条件保存後にデータが反映されます
        </div>
      </div>
      <table class="c-table c-table--condition">
        <thead>
          <tr>
            <th class="c-table__cell--center u-w160 is-sortable">
              <span class="c-table__text">配信条件</span>
              <sort-switch name="id" :order="sortTargets.id" @on-click="onSortButtonClick($event)" />
            </th>
            <th class="c-table__cell--center u-w290 is-sortable">
              <span class="c-table__text">配信条件名</span>
              <sort-switch name="title" :order="sortTargets.title" @on-click="onSortButtonClick($event)" />
            </th>
            <th class="c-table__cell--center is-sortable">
              <span class="c-table__text">条件内容</span>
            </th>
          </tr>
        </thead>
        <topic-condition-list-item
          v-for="(topicCondition,index) in topicConditions.data"
          :key="index"
          :topic-condition="topicCondition"
          :condition-info="conditionInfo"
          @delete-click="onDeleteClick"
          @copy-click="onCopyClick"
          @edit-click="onEditClick"
        />
      </table>
      <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
    </div>

    <!-- モーダル: 削除確認 -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--common"
      title="以下の配信条件を削除してもよろしいですか?"
      :body="'配信条件 : ' + currentTopicConditionId"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteCondition
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModal"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    conditionInfo: Object,
  },
  data: () => {
    return {
      sortTargets: {
        id: -1,
        type: 0,
        title: 0,
      },
      topicConditions: [],
      currentTopicConditionId: '',
      currentSortTarget: null,
      currentSortOrder: null,
      paginationInfo: null,
      page: 1,

      isDeleteCondition: false,
      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
    }
  },
  mounted: function() {
    this.loadData();
  },
  methods: {
    loadData: function() {
      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0){
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメタ作成
      const params = {
        params: {
          sort: sortTarget,
          order: order,
          page: this.page,
        }
      };

      this.isLoading = true;
      this.isLoaded = false;

      // 配信状況データの取得処理実行
      axios.get('/api/topic-condition/list',params)
        .then(res => {
          this.topicConditions = res.data.topic_conditions;
          this.paginationInfo = res.data.topic_conditions;
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            this.isEmpty = (res.data.topic_conditions.total < 1) ? true : false;
          }, 300);
        })
        .catch(error => {
          this.isError = true;
          this.errorMessage = '属性データの条件一覧の取得時にエラーが発生しました'
          this.handleHttpError(error);
          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        });
    },

    // ソートボタンクリック
    onSortButtonClick: function(target) {
      event.preventDefault();

      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

    // ページネーションボタンクリック処理
    // ページネーションコンポーネントからキックされる
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.loadData();
    },
    onCopyClick: function(topicConditionId) {
      location.href = this.conditionInfo.addUrl + '?' + 'copy=1&topic_condition_id=' + topicConditionId;
    },
    onEditClick: function(topicConditionId) {
      location.href = this.conditionInfo.addUrl + '?' + 'topic_condition_id=' + topicConditionId;
    },
    onDeleteClick: function(topicConditionId) {
      this.currentTopicConditionId = topicConditionId;
      this.isDeleteCondition = true;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },

    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteCondition = false;
      this.$refs.refControlModal.resetErrorMessage();
    },

    // クリック: 操作モーダルのENTER処理
    onEnterConrolModal() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refControlModal.showLoader();

      // パラメタ作成
      const params = {
        topic_condition_id: this.currentTopicConditionId,
      };

      // 削除処理実行
      axios.post('/api/topic-condition/delete', params)
        .then(_res => {
          this.$refs.refControlModal.hideLoader();
          this.isDeleteCondition = false;
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          let errorMessage = error?.response?.data?.message || '配信条件の削除に失敗しました';
          this.$refs.refControlModal.hideLoader();
          this.$refs.refControlModal.showErrorMessage(errorMessage);
          this.handleHttpError(error);
        });
    }
  },
}
</script>
